import { COLUMN_DEFINITIONS_CHALLNGES } from '@/src/components/game/Leaderboard/leaderboard.config';
import { PostEventReport } from '@/src/types/JamReport';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { Box, SpaceBetween, Table } from '@amzn/awsui-components-react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

const ChallengeMetrics = memo(
  ({
    reportApiData,
    openChallengeMetricsModal,
    isLoading,
  }: {
    reportApiData: PostEventReport | undefined;
    openChallengeMetricsModal: (challengeId: string) => void;
    isLoading: boolean;
  }) => {
    const { t } = useTranslation();
    return (
      <Table
        key="challenge-metrics"
        variant="embedded"
        columnDefinitions={COLUMN_DEFINITIONS_CHALLNGES(
          reportApiData?.challengeTitles || {},
          openChallengeMetricsModal
        )}
        items={reportApiData?.challengeMetrics || []}
        wrapLines
        sortingDisabled
        empty={
          <Box margin={{ vertical: 'xs' }} textAlign="center" color="inherit">
            <SpaceBetween size="m">
              <b>{t(i18nKeys.jamDashboard.leaderboard.table.emptyMessage)}</b>
            </SpaceBetween>
          </Box>
        }
        loading={isLoading}
      />
    );
  }
);

export default ChallengeMetrics;
